import './App.scss';
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from 'react';
import { connect } from "react-redux";
import { isLogin, setUserData, setCustomerData, setWallet, setPermission, setBill, setProfit, setRoute, setWhiteLabelData } from "./actions";
import { setBotcharge } from './actions/botChargeAction';
import { LocalStorageService } from './services/LocalStorage';
import AxiosService from './services/APIService';
import webSocketService from './services/websocketService';
import ProtectedRoute from './security/ProtectedRoute';

// Layouts
import AdminLayout from './components/AdminLayout';
// Auth pages
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import RegistrationReference from './pages/RegistrationReference';
import WlRegister from './pages/WlRegister';

// Admin pages
import AdminDashboard from './pages/AdminDashboard';
import Users from './pages/Users';
import PendingUser from './pages/PendingUser';
import CloseUser from './pages/CloseUser';
import Brokers from './pages/Brokers';
import Server from './pages/Server';
import Team from './pages/Team';
import Profit from './pages/Profit';
import UserProfile from './pages/UserProfile';
import DepositReport from './pages/DepositReport';
import WithdrawReport from './pages/WithdrawReport';
import BotReport from './pages/BotReport';
import NoteReq from './pages/NoteReq';
import SettingReq from './pages/SettingReq';
import BotFile from './pages/BotFile';
import Announcement from './pages/Announcement';
import QrCode from './pages/QrCode';
import BotSettings from './pages/BotSettings';



import Leads from './pages/whiteLabel/Leads';


// Pip-Grid pages
import AAdminDashboard from './pages/PipGrid/Dashboard';
import UserRequest from './pages/PipGrid/UsersRequests';
import UsersList from './pages/PipGrid/UsersList';
import LeadsList from './pages/PipGrid/LeadsList';
import PipGridNotes from './pages/PipGrid/Notes';
import Setting from './pages/PipGrid/Setting';
import PromoCode from './pages/PipGrid/PromoCode';
import AffiliateRequest from './pages/PipGrid/Affiliate/AffiliateRequest';
import AffiliateUsers from './pages/PipGrid/Affiliate/AffiliateUsers';
import PayoutRequest from './pages/PipGrid/Payout/PayoutRequest';
import PayoutHistory from './pages/PipGrid/Payout/PayoutHistory';


// User pages
import UserRegistration from './pages/UserRegistration';
import { getLoginRoute } from './utils/commonFunc';
import ExhibitionForm from './pages/whiteLabel/ExhibitionForm';
import MakeMyProfitInquiryForm from './pages/whiteLabel/MakeMyProfitInquiryForm';
import WhiteLabelInquiryForm from './pages/whiteLabel/WhiteLabelInquiryForm';
import PipGridInquiry from './pages/PipGrid/PipGridInquiry';
import WebsiteContent from './pages/PipGrid/WebsiteContent';
import AdminExhibitionForm from './pages/whiteLabelAdmin/AdminExhibitionForm';
import UsersRewards from './pages/PipGrid/UsersRewards';

// Route configurations
const adminRoutes = [
    { path: '/home', component: AdminDashboard },
    { path: '/users', component: Users },
    { path: '/pending-users', component: PendingUser },
    { path: '/close-user', component: CloseUser },
    { path: '/deposit-report', component: DepositReport },
    { path: '/withdraw-report', component: WithdrawReport },
    { path: '/botcharge-report', component: BotReport },
    { path: '/broker', component: Brokers },
    { path: '/user-profile', component: UserProfile },
    { path: '/server', component: Server },
    { path: '/profit', component: Profit },
    { path: '/note-request', component: NoteReq },
    { path: '/setting-request', component: SettingReq },
    { path: '/bot-file', component: BotFile },
    { path: '/announcement', component: Announcement },
    { path: '/qr-code', component: QrCode },
    { path: '/bot-performance', component: BotSettings },
];

const pipGridRoutes = [
    { path: '/pip-Grid/home', component: AAdminDashboard },
    { path: '/pip-Grid/users-request', component: UserRequest },
    { path: '/pip-Grid/users-list', component: UsersList },
    { path: '/pip-Grid/users-rewards', component: UsersRewards },
    { path: '/pip-Grid/leads-list', component: LeadsList },
    { path: '/pip-Grid/notes', component: PipGridNotes },
    { path: '/pip-Grid/setting', component: Setting },
    { path: '/pip-Grid/promo-code', component: PromoCode },
    { path: '/pip-Grid/affiliate-request', component: AffiliateRequest },
    { path: '/pip-Grid/affiliate-users', component: AffiliateUsers },
    { path: '/pip-Grid/payout-request', component: PayoutRequest },
    { path: '/pip-Grid/payout-history', component: PayoutHistory },
    { path: '/pip-Grid/inquiry', component: PipGridInquiry },
    { path: '/pip-Grid/website-content', component: WebsiteContent },
];



function App({ isLogin, setUserData, setWhiteLabelData, setWallet, setPermission, user, customer, setBill, setProfit, setBotcharge, setRoute, setCustomerData }) {
    const location = useLocation();
    const axiosService = new AxiosService();

    useEffect(() => {
        const token = LocalStorageService.getItem("userToken");
        document.title = 'PIPGRID ADMIN V1.0';

        if (token) {
            checkAuthentication();
        } else {
            isLogin(false);
            setUserData(null);
        }

        webSocketService.connect(process.env.REACT_APP_SOCKET_URL);
    }, []);

    useEffect(() => {
        setRoute(location.pathname);
    }, [location]);

    const checkAuthentication = async () => {
        try {
            const res = await axiosService.get("/auth/me");
            isLogin(true);
            setUserData(res?.user);

            if (res?.user?.role === "CUSTOMER") {
                setCustomerData(res?.customer);
                setWallet(res?.wallet);
                setBill(res?.bill);
                setProfit(res?.totalProfit);
                setBotcharge(res?.botCharge);
            }

            if (res?.user?.role === "WHITE_LABEL") {
                setWhiteLabelData(res?.white_label);
                setBill(res?.bill);
            }

            if (res?.user?.role === "SUBADMIN") {
                setPermission(res?.permission);
            }
        } catch (error) {
            isLogin(false);
            setUserData(null);
            LocalStorageService.removeItem("userToken");
        }
    };

    const navigationTo = () => {
        const userData = LocalStorageService.getItem("user");
        const urlParams = new URLSearchParams(window.location.search);
        const tokenParam = urlParams.get('token');
        const token = tokenParam || LocalStorageService.getItem("userToken");

        if (userData && token) {
            if (userData?.role === "ADMIN" && !tokenParam) {
                return "/pip-Grid/home";
            } else if (userData?.role === "ADMIN" && tokenParam) {
                return `/dashboard?token=${tokenParam}`;
            } else {
                return "/dashboard";
            }
        }

        return getLoginRoute({ ...user, ...customer });
    };

    // Helper function to generate routes
    const generateRoutes = (routes, layout, role) => {
        return routes.map(route => (
            <Route
                key={route.path}
                path={route.path}
                element={<ProtectedRoute layout={layout} component={route.component} role={role} />}
            />
        ));
    };

    return (
        <Routes>
            {/* Public routes */}
            <Route path="/login/:role" Component={Login} />
            <Route path="/reset-password" Component={ResetPassword} />
            <Route path="/reference" Component={RegistrationReference} />
            <Route path='/wl-registration' Component={WlRegister} />
            <Route path='/leads' element={<Leads />} />
            <Route path='/white_label/inquiry' element={<WhiteLabelInquiryForm />} />
            <Route path='/white_label/exhibition' element={<ExhibitionForm />} />
            <Route path='/make-my-profit/inquiry' element={<MakeMyProfitInquiryForm />} />
            <Route path='/admin/white_label/exhibition' element={<AdminExhibitionForm />} />
            <Route path='/registration' Component={UserRegistration} />


            {/* Admin routes */}
            {generateRoutes(adminRoutes, AdminLayout, 'admin')}

            {/* Team route - only for admin */}
            {user?.role === "ADMIN" && (
                <Route path='/team' element={<ProtectedRoute layout={AdminLayout} component={Team} role='admin' />} />
            )}


            {/* Pip-Grid routes */}
            {generateRoutes(pipGridRoutes, AdminLayout, 'admin')}



            {/* Default route */}
            <Route path='/' element={<Navigate to={navigationTo()} />} />
        </Routes>
    );
}

const mapStateToProps = ({ login }) => {
    const { user, customer } = login;
    return { user, customer };
};

const mapDispatchToProps = {
    setUserData,
    isLogin,
    setCustomerData,
    setWallet,
    setPermission,
    setBill,
    setProfit,
    setBotcharge,
    setRoute,
    setWhiteLabelData
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
